import { Link } from 'react-router-dom';
import { kanal } from '@beholder/shared';
import type { MailListenEintrag } from '@beholder/shared/module/mail';
import type { ModulSeiteProps, WebModul } from '../../core/modul';
import { api, modulPfad } from '../../core/api';
import { useLive } from '../../core/live';
import { Symbol } from '../../core/symbole';
import { Karte as KarteRahmen, Meldung, useDaten } from '../../core/ui';
import { ArtMarke, Verdacht } from './gemeinsam';
import { Seite, type MailStatusProjekt } from './Seite';
import { Postfach } from './Postfach';
import './stil.css';

/** Karte auf der Projektübersicht: neue Mails, Rechnungen/Angebote, Hinweise. */
function Karte({ projekt, ich }: ModulSeiteProps) {
  const liste = useDaten(() => api.get<MailListenEintrag[]>(modulPfad(projekt.id, 'mail', 'mails')), [projekt.id]);
  const status = useDaten(() => api.get<MailStatusProjekt>(modulPfad(projekt.id, 'mail', 'status')), [projekt.id]);
  useLive(kanal(projekt.id, 'mail'), () => void liste.neuLaden());
  const mails = liste.daten ?? [];
  const woche = Date.now() - 7 * 86_400_000;
  const neu = mails.filter((m) => new Date(m.eingegangenAm).getTime() > woche).length;
  const belege = mails.filter((m) => m.art === 'rechnung' || m.art === 'angebot').length;
  const einnahmen = mails.filter((m) => m.art === 'einnahme').length;
  return (
    <KarteRahmen
      titel={
        <Link to={`/p/${projekt.id}/mail`} style={{ color: 'inherit', textDecoration: 'none' }}>
          Mail
        </Link>
      }
    >
      <div className="stapel" style={{ gap: 8 }}>
        <Meldung>{liste.fehler}</Meldung>
        <p className="leise klein" style={{ margin: 0 }}>
          {mails.length === 0
            ? 'Noch keine Mails.'
            : `${mails.length} Mail${mails.length === 1 ? '' : 's'}, ${neu} neu in den letzten 7 Tagen${belege ? `, ${belege} Rechnung${belege === 1 ? '' : 'en'}/Angebote` : ''}${einnahmen ? `, ${einnahmen} Einnahme${einnahmen === 1 ? '' : 'n'}` : ''}.`}
          {ich.istAdmin && status.daten?.unsortiert ? (
            <>
              {' '}
              <Link to="/modul/mail">{status.daten.unsortiert} unsortiert</Link>.
            </>
          ) : (
            ''
          )}
          {status.daten && !status.daten.eingerichtet && ' Postfach noch nicht eingerichtet.'}
        </p>
        <ul className="ml-karte-liste">
          {mails.slice(0, 4).map((m) => (
            <li key={m.id}>
              <ArtMarke art={m.art} />
              <Verdacht m={m} />
              <Link to={`/p/${projekt.id}/mail/${m.id}`} title={m.betreff}>
                {m.betreff}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </KarteRahmen>
  );
}

const mail: WebModul = {
  id: 'mail',
  name: 'Mail',
  reihenfolge: 50,
  symbol: Symbol.mail,
  Seite,
  Karte,
  // Posteingang „Unsortiert“ und Postfach-Verwaltung projektübergreifend unter /modul/mail
  GlobalSeite: Postfach,
  globalName: 'Posteingang',
  globalSichtbar: (ich) => ich.istAdmin,
};
export default mail;
